<script setup lang="ts">
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocale } from 'vuetify'
import { useDarkMode } from '@/composables/useDarkMode'
import { usePrefs } from '@/stores/prefs'
import AppShell from '@/layouts/AppShell.vue'
import '@/styles/scrollbars.css'

const { locale } = useI18n()
// Vuetify's own strings (table footer, pagination, loading) follow the app's language.
const vuetifyLocale = useLocale()
const prefs = usePrefs()
useDarkMode().apply()

watch(
    () => prefs.locale,
    (value) => {
        locale.value = value
        vuetifyLocale.current.value = value
        document.documentElement.lang = value
    },
    { immediate: true },
)
</script>

<template>
    <v-app>
        <AppShell />
    </v-app>
</template>
